import type {TableComparisonConfig} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/reportsWorkspaceCapability/domain/ReportJson";

export function createDefaultTableComparisonConfig(): TableComparisonConfig {
    return {
        enabled: false,
        startDateIso: null,
        endDateIso: null,
    };
}
